import { EBaseApiTags } from 'shared/typings';

import { enhancedApi } from './codegen.api';

export const notificationApi = enhancedApi.enhanceEndpoints({
	addTagTypes: [EBaseApiTags.NOTIFICATIONS_COUNT, EBaseApiTags.NOTIFICATIONS_LIST],
	endpoints: {
		// TODO:
		// notificationsList: {
		// 	query: (params) => ({
		// 		url: `notifications/${params ? '?' : ''}${params}`,
		// 	}),
		// 	serializeQueryArgs: ({ endpointName }) => {
		// 		return endpointName;
		// 	},
		// 	merge: (cache, response, otherArgs) => {
		// 		const offset = new URLSearchParams(otherArgs.arg).get(EPaginationParams.OFFSET);
		//
		// 		return !offset
		// 			? response
		// 			: {
		// 				...response,
		// 				results: [...(cache.results || []), ...(response.results || [])],
		// 			};
		// 	},
		// 	forceRefetch({ currentArg, previousArg }) {
		// 		return currentArg !== previousArg;
		// 	},
		// },
		notificationsMarkAsReadCreate: {
			invalidatesTags: (_, error) => (error ? [] : [EBaseApiTags.NOTIFICATIONS_COUNT]),
		},
		notificationsUnreadCountRetrieve: {
			providesTags: [EBaseApiTags.NOTIFICATIONS_COUNT],
		},
	},
});

export const {
	useNotificationsListQuery,
	useNotificationsMarkAsReadCreateMutation,
	useNotificationsUnreadCountRetrieveQuery,
} = notificationApi;
